import React, {useState, useEffect} from 'react'
import {Paper, Stepper, Step, StepLabel, Typography, CircularProgress, Divider, Button, CssBaseline} from '@material-ui/core'
import useStyles from './styles'
import {Link, useHistory } from 'react-router-dom'
import AddressForm from '../AddressForm';
import PaymentForm from '../PaymentForm';
import {commerce} from '../../../lib/commerce'

const steps = ["Shipping address", "Payment details"]

const Checkout = ({cart, order, onCaptureCheckout, error}) => {
    const [activeStep, setActiveStep] = useState(0);
    const [checkoutToken, setCheckoutToken] = useState(null);
    const [shippingData, setShippingData] = useState({});
    const [isFinished, setIsFinished] = useState(false);
    const classes = useStyles();
    const history = useHistory();

    // const generateToken = async () => {
    //     try {
    //         const token = await commerce.checkout.generateToken(cart.id, {type: 'cart'});
    //         console.log(token);
    //         setCheckoutToken(token)
    //     } catch (error) {
            
    //     }
    // }

    useEffect(() => {
        if(cart && Object.keys(cart).length) {
            (async () => {
                try {
                    const token = await commerce.checkout.generateToken(cart.id, {type: 'cart'});
                    // console.log(token);
                    setCheckoutToken(token)
                } catch (error) {
                    // after check out complet, the cart is desapear, so we gott an error so we fixe that with history wish is a return to specific point
                    if(activeStep !== steps.length) history.push('/');
                }
            })()
        }
    }, [cart]);

    const nextStep = () => setActiveStep(activeStep => activeStep + 1);
    const prevStep = () => setActiveStep(activeStep => activeStep - 1);

    const next = (data) => {
        setShippingData(data);

        nextStep();
    }

    const timeout = () => {
        setTimeout(() => {
            setIsFinished(true);
        }, 3000);
    }

    const Form = () => activeStep ? <PaymentForm shippingData = {shippingData} checkoutToken = {checkoutToken} backStep = {prevStep} nextStep = {nextStep} onCaptureCheckout = {onCaptureCheckout} timeout = {timeout}/> : <AddressForm checkoutToken = {checkoutToken} next = {next} />;

    let Confirmation = () => order.customer ? (
        <>
            <div>
                <Typography>Thank you for your purchase, {order.customer.firstname} {order.customer.lastname}</Typography>
                <Divider className = {classes.divider}/>
                <Typography variant = "subtitle2">Order ref: {order.customer_reference}</Typography>
            </div>
            <br />
            <Button component = {Link} to = "/" variant = "outlined" type = "button">Back to Home</Button>
        </>
    ) : 
    // isFinished ? (
    //     <>
    //         <div>
    //             <Typography>Thank you for your purchase</Typography>
    //             <Divider className = {classes.divider}/>
    //         </div>
    //         <br />
    //         <Button component = {Link} to = "/" variant = "outlined" type = "button">Back to Home</Button>
    //     </>
    // ) :
     (
        <div className = {classes.spinner}>
            <CircularProgress />
        </div>
    );

    if(error) {
        Confirmation = () => (
            <>
                <Typography variant = "h5">Error: {error}</Typography>
                <br />
                <Button component = {Link} to = "/" variant = "outlined" type = "button">Back to Home</Button>
            </>
        )
    }

    return (
        <>
            <CssBaseline />
            <div className = {classes.toolbar} />
            <main className={classes.layout}>
                <Paper className = {classes.paper}>
                    <Typography variant = "h4" align = "center">Checkout</Typography>
                    <Stepper activeStep = {activeStep} className = {classes.stepper}>
                        {
                            steps.map(step => (
                                <Step key = {step}>
                                    <StepLabel>{step}</StepLabel>
                                </Step>
                            ))
                        }
                    </Stepper>
                    {activeStep === steps.length ? <Confirmation /> : checkoutToken && <Form />}
                </Paper>
            </main>
        </>
    )
}

export default Checkout
